import * as React from "react";
import styled from "styled-components";

import { Metrics } from "../../vars";

export class NavbarDropdownMenuButton extends React.Component<any, any> {
  buttonRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
  }
  handleClick = (e) => {
    this.buttonRef.current.blur();

    this.props.onClick(e);
  };

  render() {
    const { children, className } = this.props;

    return (
      <button
        className={`analytics-nav ${className}`}
        onClick={this.handleClick}
        ref={this.buttonRef}
      >
        <span>{children}</span>
      </button>
    );
  }
}

export default styled(NavbarDropdownMenuButton)`
  display: flex;
  width: 100%;
  background: none;
  border: none;
  margin-top: ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_ITEM_Y}px;
  padding: ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_ITEM_Y * 2}px 0
    ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_ITEM_Y}px;
  border-top: 1px solid ${(p) => p.theme.colors.grey100};
  font-size: ${Metrics.FontSizes.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
  line-height: ${Metrics.LineHeights.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
  cursor: pointer;

  span {
    flex: 1;
    font-weight: 600;
    text-align: left;
    color: ${(p) => p.theme.colors.grey500};
  }

  &:hover span,
  &:hover i:before {
    color: ${(p) => p.theme.colors.primary};
  }

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;
